<template>
  <div class="header">
    <a-row>
      <a-col :span="12"
             :xs="{span: 18}">
        <div class="systemName">
          <img class="systemName-logo"
               src="../../../static/img/logo_ycx.png"
               height="32px"
               alt="系统LOGO">
        </div>
      </a-col>
      <!-- <a-col :span="12"
             :xs="{span: 6}">
        <div class="systemRegist"
             v-if="pageType === 'login'"></div>
        <div class="systemRegist"
             v-else-if="pageType === 'forget'">
          <span class="systemRegist-span">已有平台账号？</span>
          <router-link to="'/login'"
                       class="systemRegist-a">立即登录</router-link>
        </div>
      </a-col> -->
    </a-row>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: ['systemName', 'pageType'],
  beforeCreate () {
    let fontSize = 20 * document.body.clientWidth / 1920
    if (fontSize < 14.25) {
      document.getElementsByTagName('html')[0].style.fontSize = '14.25px'
    } else {
      document.getElementsByTagName('html')[0].style.fontSize = fontSize + 'px'
    }
  },
  mounted () {
    window.onresize = () => {
      this.$nextTick(() => {
        let fontSize = 20 * document.body.clientWidth / 1920
        if (fontSize < 14.25) {
          document.getElementsByTagName('html')[0].style.fontSize = '14.25px'
        } else {
          document.getElementsByTagName('html')[0].style.fontSize = fontSize + 'px'
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  position: fixed;
  top: 0;
  width: 100%;
  height: 3rem;
  font-size: 1rem;
  background-color: #fff;
  z-index: 9;
  .ant-row {
    height: 3rem;
    padding: 0 2.25rem;
    line-height: 3rem;
    .systemName {
      display: flex;
      height: 3rem;
      align-items: center;
      &-logo {
      }
      &-divider {
        width: 0.05rem;
        height: 1.4rem;
        margin: 0 0.75rem 0 0.6rem;
        border-radius: 0.05rem;
        background-color: #ffffff;
      }
      &-login {
        height: 100%;
        color: #ffffff;
        font-size: 1.2rem;
      }
    }
    .systemRegist {
      font-size: 0.9rem;
      text-align: right;
      &-span {
        margin-right: 0.7rem;
        color: #ffffff;
      }
      &-a {
        color: #5c86e5;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .systemRegist-span {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// Header.vue?062ed436